import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { selectActiveRoomTab } from "../../../../redux/actions/lobby/actions.js";
import Button from "../../../../core/Button/Button.jsx";
import { joinRoom } from "../../../../redux/actions/cash/actions.js";
import { closeRoom } from "../../../../redux/actions/rooms/actions.js";
import { useTranslation } from "react-i18next";

function WaitingStateButton({ row }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userId = useSelector(state => state.user.id);
    const isMobile = useSelector(state => state.user.isMobile);
    const { table_room_id, table_room_player, table_room_is_bonus } = row;
    const waitingProcesses = useSelector(state => state.cash.waitingProcesses);
    const entered = useSelector(state => state.rooms);
    const handleJoinRoom = () => dispatch(joinRoom({roomId: table_room_id, isBonus: table_room_is_bonus}));

    const handleCloseRoom = () => dispatch(closeRoom({ roomId: table_room_id }))

    const handleSelectRoomTab = () => dispatch(selectActiveRoomTab({ roomId: table_room_id }));
    const renderButton = () => {
        if (waitingProcesses.includes(table_room_id)) {
            if (isMobile) {
                return <i className="icon-spinner8 rotate" onClick={handleJoinRoom} />;
            } else {
                return (
                    <div className="button-size">
                        <Button
                            onClick={handleJoinRoom}
                            type={"blue-border"}
                            text={t('buttons.loading')}
                        />
                    </div>
                );
            }
        }
        if (table_room_player !== userId) {
            if (isMobile) {
                return <i
                    onClick={handleJoinRoom}
                    className={table_room_is_bonus ? "icon-bonus" : "icon-user-plus"}
                />
            } else {
                return (
                    <div className="button-size">
                        {
                            entered[table_room_id]
                                ?
                                <Button
                                    type="blue-border"
                                    text={t('buttons.reject')}
                                />
                                :
                                <Button
                                    onClick={handleJoinRoom}
                                    text={!table_room_is_bonus ? t('buttons.join') : t('buttons.with_bonus')}
                                    type={table_room_is_bonus ? "gold" : "green"}
                                />
                        }

                    </div>
                );
            }
        } else {
            if (isMobile) {
                return <i className="icon-user-minus" onClick={handleSelectRoomTab} />;
            } else {
                return (
                    <>
                        <i className="icon-close close-hover" onClick={handleCloseRoom} />
                        <div className="button-size">
                            <Button
                                onClick={handleSelectRoomTab}
                                type="blue-border"
                                text={t('buttons.back')}
                            />
                        </div>
                    </>
                );
            }
        }
    };

    return <div className="table-buttons-wrapper">{renderButton()}</div>;
}

export default WaitingStateButton;
